import { useMutation, useQueryClient } from '@tanstack/react-query';

import { QueryKey } from '@/types/query';
import { RejectCandidateParams } from '../model';
import { recruiterRejectsCandidateClient } from './client';
import { useRejectCandidateMutationCallbacks } from './use-reject-candidate-mutation-callbacks';

export const useRejectCandidateMutation = () => {
  const queryClient = useQueryClient();
  const callbacks = useRejectCandidateMutationCallbacks(queryClient);

  return useMutation({
    mutationKey: [QueryKey.useRejectCandidateMutation],
    mutationFn: async ({ esPersonId, campaignId, reason, improvedJobId }: RejectCandidateParams) => {
      await recruiterRejectsCandidateClient.rejectAppliedCandidate(esPersonId, campaignId, improvedJobId);
      await recruiterRejectsCandidateClient.addCandidateNote(esPersonId, { content: reason, campaign: campaignId });
      await recruiterRejectsCandidateClient.hideCandidate(esPersonId, campaignId);
    },
    ...callbacks,
  });
};
